import { Container, Tabs } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { ReactNode } from "react";
import { StrengthenReferralHeader } from "./components/StrengthenReferralHeader/StrengthenReferralHeader";
import styles from "./strengthen-referral.module.scss";

interface StrengthenReferralProps {
  appealId: string;
  activeTab: string;
  tabContent: ReactNode;
}

export function StrengthenReferral({
  appealId,
  activeTab,
  tabContent,
}: StrengthenReferralProps) {
  const navigate = useNavigate();

  const handleTabChange = (value: string | null) => {
    if (value) {
      navigate(`/appeals/${appealId}/strengthen/${value}`);
    }
  };

  return (
    <Container fluid className={styles.mainContainer}>
      <StrengthenReferralHeader appealId={appealId} />

      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab value="patient">Patient</Tabs.Tab>
          <Tabs.Tab value="insurance">Insurance</Tabs.Tab>
          <Tabs.Tab value="documents">Supporting documents</Tabs.Tab>
          <Tabs.Tab value="prescriber-information">
            Prescriber Information
          </Tabs.Tab>
          <Tabs.Tab value="medical-info/diagnosis">Medical Info</Tabs.Tab>
          <Tabs.Tab value="patient-survey">Patient Survey</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={activeTab}>{tabContent}</Tabs.Panel>
      </Tabs>
    </Container>
  );
}
